export const normalizeDomain = (domain) => {
  if (!domain) return ''
  let value = String(domain).trim().toLowerCase()
  value = value.replace(/^https?:\/\//, '')
  value = value.replace(/^www\./, '')
  value = value.split('/')[0]
  return value
}

export const domainsMatch = (left, right) => {
  const a = normalizeDomain(left)
  const b = normalizeDomain(right)
  return Boolean(a && b && a === b)
}
